import { render, staticRenderFns } from "./BookRemove.vue?vue&type=template&id=aeb97ca4"
import script from "./BookRemove.vue?vue&type=script&lang=js"
export * from "./BookRemove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports